import { Container, Row } from "reactstrap";
import { SystemConfigLayout } from "../../components/SystemConfigLayout";
import { Toolbar } from "../../../components/Toolbar";
import { BoolCell } from "../../../components/grid/cells/BoolCell";
import { TokenCell } from "../../../components/grid/cells/TokenCell";
import { BoolFilter } from "../../../components/inputs/BoolFilter";
import { useCallback } from "react";
import { DESTROY, UPDATE, makeColumns, useAdministrateTable, useCreatePermission } from "../../utils";
import { AdministrateTable } from "../../components/AdministrateTable";
import { AddQaCategoryModal } from "./components/AddQaCategoryModal";
import { QaCategoryActionCell } from "./components/QaCategoryActionCell";

const useColumns = makeColumns(() => [
  {
    id: "id",
    accessor: "id",
    Header: "ID",
    Cell: TokenCell,
  },
  {
    id: "name",
    accessor: "name",
    Header: "Name",
  },
  {
    id: "active",
    accessor: "active",
    Header: "Active",
    Cell: BoolCell,
    Filter: BoolFilter,
  },
  {
    id: "actions",
    accessor: "Actions",
    Header: "Actions",
    Cell: QaCategoryActionCell,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const QaCategoriesIndex = () => {
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable();
  const columns = useColumns();
  const [canCreate] = useCreatePermission("QaCategory");

  const onAdd = useCallback(
    (message, errorDetails = []) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(message, errorDetails.length ? "warning" : "success", errorDetails);
    },
    [tableRef]
  );

  return (
    <SystemConfigLayout title="QA Categories">
      <Container fluid>
        <Row className="align-items-center mb-3">
          <Toolbar className="ml-auto">{canCreate && <AddQaCategoryModal onAdd={onAdd} color="primary" />}</Toolbar>
        </Row>
      </Container>

      <AdministrateTable
        resourceUrl={"/admin/qa_categories.json"}
        resourceName={"qa_category"}
        permissions={[UPDATE, DESTROY]}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </SystemConfigLayout>
  );
};
